import store from "features/store";
import moment from "moment";
import React, { Component, useEffect, useRef, useState } from "react";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { connect, useDispatch, useSelector } from "react-redux";
import { useParams, useLocation } from 'react-router-dom';
import { eye, RightArrowLine } from "shared/assets/icons";
import { new_image_thumbnail, sneakPeekBerry, sneakpreview, timetable } from "shared/images/images";
import { ItemsService, LocationService, SalesService } from 'shared/services';
import { isAuthorized, logout } from "shared/settings/auth";
import { MyAccountMenuList, removeSideBar, ToggleSideBar } from "../base/auth-pages/MyAccount/MyAccountMenuList";
import PaginationBox from "../base/public/HOC/PaginationBox";
let pageSize = 12
function AuctionSneakPeekSaleitemfn(props) {
    const dispatch = useDispatch()
    const statemaintenance = useSelector(state => state?.statemaintenance);
    const params = useParams();
    const [itemList, setItemList] = useState([]);
    const [watchList, setWatchList] = useState([]);
    const [locImg, setlocImg] = useState("");
    const [locationDetails, setlocationDetails] = useState({});
    const [sale, setsale] = useState({});
    const [pageLoading, setPageLoading] = useState(true);
    const [saleId, setSaleId] = useState(params?.saleId);
    const [disableWatch, setDisableWatch] = useState(false);
    const [contentload, setcontentload] = useState(false);
    const pagekey = useRef({
        total: null,
        next: null,
        previous: null
    })
    const currentindex = useRef(1)

    useEffect(() => {
        loading()
        return () => {

        }
    }, []);

    const loading = async () => {
        let screenState = statemaintenance?.["AuctionSneakPeekItems"]
        if(screenState) { 
            pagekey.current = screenState?.pagekey
            currentindex.current = screenState?.previousPage
            await getSaleItemList(screenState?.currentPage);
        } else {
            await getSaleItemList();
        }
        await getSale();
        setPageLoading(false);
    }
    const getSale = async() => {
        const saleDetailData = {
            "sort": [{ "field": "id", "direction": "asc" }],
            "field": ["id", "title", "city", "state", "zipcode", "starttime", "endtime", "itemcount", "status", "provenance", "timezoneid", "timezonename", "endtimeutc", "itemimageurl", "url", "locationid"],
            // filter: [{ "field": "id", "value": params?.saleId, "op": "=", "join": "AND" }],
            // "page": { "size": 1 }
        };
        await SalesService.getSaleDetails(params?.saleId,saleDetailData).then(async(response) => {
            let saleDetail = response?.data?.data?.[0] || {}
            setsale(saleDetail)
            await getLocData(saleDetail?.locationid);

        }).catch((err) => {
        })
    }
    const getLocData = async (id) => {
        await LocationService.getLocationDetails(id , { data: {} }).then(
            location => {
                setlocationDetails(location.data.data[0])
            }
        ).catch((error) => {
            // TODO: Error message handle
            if (error?.status === 401) {
                store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                logout(props.history, false);
            }
        });
        const locationImageData = { "filter": [{ "field": "locationid", "value": id, "op": "=", "join": "AND" }] };
        await LocationService.getLocationImagesList(locationImageData).then(
            resp => {
                let data = resp?.data?.data
                let locationImage = {}
                data?.map((i) => {
                    locationImage[i?.name] = i?.url
                })
                setlocImg(locationImage)
            }
        ).catch((error) => {
            // TODO: Error message handle
        });
    }

    const getSaleItemList = async (key = null) => {
        let payload = {
            "sort": [{ "field": "starttime", "direction": "asc" }],
            "field": ["id", "saleid", "title", "displayimageurl", "isdisplayimage"],
            "filter": [
                { "field": "saleid", "value": params?.saleId, "op": "=", "join": "AND", },
                { "field": "isdeleted", "value": 0, "op": "=", "join": "AND" },
                { "field": "isdisplayimage", "value": 1, "op": "=", "join": "AND" }
            ],
            "page": { 'size': pageSize },
        };
        delete payload["page"]["previous"]
        delete payload["page"]["next"]
        delete payload["page"]["total"]
        delete payload["page"]["from"]
        delete payload["page"]["to"]
        if (key != null) {
            if (key == currentindex.current + 1 && pagekey.current?.next != null) {
                payload["page"]["next"] = pagekey.current?.next
            } else if (key == currentindex.current - 1 && pagekey.current?.previous != null) {
                payload["page"]["previous"] = pagekey.current?.previous
            } else {
                payload["page"].total = pagekey.current?.total;
                payload["page"].from = currentindex.current;
                payload["page"].to = key;

                if (key > currentindex.current) {
                    payload["page"]["next"] = pagekey.current?.next
                } else {
                    payload["page"]["previous"] = pagekey.current?.previous
                }
            }

            let pusttoStore = { ...statemaintenance }
            pusttoStore["AuctionSneakPeekItems"] = {
                ...pusttoStore?.["AuctionSneakPeekItems"],
                currentPage: key == null ? 1 : key,
                pagekey: pagekey.current,
                previousPage: currentindex.current

            }
            dispatch({
                type: 'PUSH_TO_STATE', payload: pusttoStore
            });
        } 
        currentindex.current = key == null ? 1 : key
        ItemsService.getSneekPeakList(payload).then(
            async (response) => {
                pagekey.current ={
                    total: response?.data?.page?.total ? response?.data?.page?.total : pagekey.current.total ? pagekey.current.total : null,
                    next: response.data.page && response.data.page.keyset && response.data.page.keyset.next ? response.data.page.keyset.next : null,
                    previous: response.data.page && response.data.page.keyset && response.data.page.keyset.previous ? response.data.page.keyset.previous : null,
                }
                const temp = response.data.data;
                setItemList(temp);
                setcontentload(false);
                await getWatchList(temp);
            }
        ).catch((error) => {
            if (error?.status === 401) {
                store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                logout(props.history, false);
                setcontentload(false);
            }
        });
    }

    const getWatchList = (itemLists) => {
        if (isAuthorized()) {
            let itemId = [];
            itemLists.forEach(item => {
                itemId.push(item.id ? item.id : item.itemid);
            });
            if (itemLists.length > 0) {
                const data = {
                    "sort": [{ "field": "id", "direction": "desc" }],
                    "filter": [{ "field": "itemid", "value": [itemId], "op": "IN", "join": "AND" }],
                    "field": ["itemid"],
                    "page": { "size": itemLists.length + 1 }
                };
                ItemsService.getWatchListItem(data).then(
                    response => {
                        const watch = response.data.data;
                        setWatchList(watch)
                    }
                ).catch(error => {
                });
            }
        } else {
        }
    }

    const watching = (item) => {
        setDisableWatch(true);
        if (!isAuthorized()) {
            return
        }
        if (watchList.filter(i => i?.itemid === item?.id).length > 0) {
            const removeData = {
                "data": {
                    "itemIds": [item?.id]
                }
            };
            ItemsService.removeFromWatch(removeData).then(
                response => {
                    setDisableWatch(false);
                    getWatchList(itemList)
                }
            ).catch(error => {
            });
        } else {
            const addData = {
                "data": [
                    {
                        "itemid": item?.id
                    }
                ]
            }
            ItemsService.addToWatch(addData).then(
                response => {
                    setDisableWatch(false);
                    getWatchList(itemList)
                }
            ).catch(error => {
            });
        }

    }

    const navigateToItem = (item) => {
        props.history.push({
            pathname: `/my-account/premier/auction-sneak-peak-item/${params?.saleId}/item/${item?.id}`, state: {
                item,
                itemId: item.id,
                saleId: saleId,
                sale: sale,
                locationData: locationDetails,
                locationImg: locImg
            }
        });
    }

    const moreSaleForLocation = () => {
        const location = locationDetails;
        if (location.id) {
            const locationUrl = location.locationcode ? `/estate-sales/${location.locationstatecode}/${location.locationcode}` : `/estate-sales/${location.locationstatecode}`;
            props.history.push(locationUrl);
        }
    }

    const getMoreList = (index) => {
        setcontentload(true);
        getSaleItemList(index);
    }

    if (pageLoading)
        return (
            <div className="h-100 d-flex align-items-center justify-content-center">
                <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
            </div>)
    return (
        <div className="asp-items">
            <Helmet>
                <title>CTBids | Premier Auction Sneak Peek</title>
            </Helmet>
            {props.user.suspensionstatus === "ALL" ?
                <div className="w-100" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                    <div style={{ fontSize: '24px', fontWeight: 'bold', textAlign: 'center', width: '60%' }}>
                        You are currently suspended from bidding on CTBids. Please reach out to <a style={{ color: '#A50050' }} href="tel:(844) 4-BID-HELP" >(844) 4-BID-HELP</a>  or email <a style={{ color: '#A50050' }} href="mailto:ctbidshelp@caringtransitions.com">ctbidshelp@caringtransitions.com</a> if you have any questions.
                    </div>
                </div> :
                <div className="asp">
                    <div className="asps_container w-100">
                        <div className="asp_container">
                            <div className="asp-header">
                                <div className="header">
                                    <img className="headlogo" src={sneakPeekBerry} />
                                    <div className="title">
                                        <div className="atitle">Auction Sneak Peek</div>
                                        <div className="head_cont">You are among the first to preview these auction items from {locationDetails?.title ? locationDetails?.title : sale?.locationtitle}.</div>
                                        <div className="head_cont">Item description and pictures may be updated prior to the Live Auction tentatively starting { moment(sale?.starttime).format("MMMM DD")}.</div>
                                        <Button className="btn-secondary my-2" onClick={() => {
                                            props.history.push({ pathname: "/my-account/premier/auction-sneak-peak" });
                                        }}>Return To Sneak Peek Listings</Button>
                                    </div>
                                </div>
                                <div className="location-card">
                                    <div className="location-head">
                                        <div className="left">
                                            <div className="imgcontainer">
                                                <img className="location-img" src={locImg?.banner || locImg?.profile || new_image_thumbnail} alt="location image" />
                                            </div>
                                        </div>
                                        <div className="right">
                                            <div className="locationtitle"> {locationDetails?.title}</div>
                                            <div className="locationcity my-2">{locationDetails?.city}</div>
                                            {locationDetails?.auctioneerlicense && <div className='text-secondary mt-3' style={{ wordBreak: "break-all" }}>License: {locationDetails?.auctioneerlicense}</div>}

                                        </div>
                                    </div>
                                    <Button className=' w-100 btn-grey rounded text-bold estate-resp d-flex gap-2 justify-content-center align-items-center' onClick={() => {  moreSaleForLocation() }}>
                                        <div>View Estate Sales</div>
                                        <div > {RightArrowLine}</div>
                                    </Button>
                                </div>
                            </div>
                            <div>
                                {contentload ? <div className="loader d-flex align-items-center justify-content-center">
                                    <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                                </div> : <div className="itemlist">
                                    <Row xs={1} sm={2} md={3} lg={4}>
                                        {itemList?.map((item, index) => (
                                            <Col key={`items_${index}`} className=" clickable">
                                                <div className={"itemcard"}>
                                                    <div className="image-card clickable" role={"button"} onClick={() => { navigateToItem(item) }}>
                                                        <div className="img-container">
                                                            <img className="items-image" src={item.displayimageurl ? item.displayimageurl : item.displayimage ? item.displayimage : new_image_thumbnail} alt="item"></img>
                                                        </div>
                                                    </div>
                                                    <div className="item_text">
                                                        <div className="item-card-title" style={{
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis"
                                                        }}>{item?.title}</div>
                                                        <button className={`watchbtn  ${watchList.filter(i => i?.itemid === item?.id).length > 0 ? "watching" : ""}`} onClick={() => { watching(item) }} disabled={disableWatch}>
                                                            {eye}
                                                        </button>
                                                    </div>
                                                </div>
                                            </Col>
                                        ))}
                                    </Row>
                                </div>}
                            </div>
                        </div>
                    </div>
                    <PaginationBox totalrecord={Math.ceil(pagekey.current?.total / pageSize)} onclickBox={(index) => {
                        getMoreList(index)
                    }} currentIndex={currentindex.current} />
                    <div className="d-flex flex-row justify-content-center mrbt-2 sneak-item-resp py-5">
                        <img className="logobid" src={sneakpreview} />
                    </div>
                </div>}

        </div>
    )
}

class AuctionSneakPeekSaleitem extends Component {
    constructor(props) {
        super(props);
        this.buyrId = this.props.user.id
    }

    componentDidMount() {
        store.dispatch({ type: 'SIDEBAR_MENU_LIST', payload: { menuList: MyAccountMenuList(), withSpan: false } });
        ToggleSideBar();
        window.addEventListener('resize', ToggleSideBar);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', ToggleSideBar);
        removeSideBar();
    }

    render() {
        return <AuctionSneakPeekSaleitemfn {...this.props} />
    }
}

export default connect(state => state)(AuctionSneakPeekSaleitem);